import React from 'react';
import '../../scss/components/Button.scss';

interface ButtonProps {
    children?:any,
    className?:string,
    wrapperClassName?:string,
    buttonType?:string,
    onClick?:any,
    fullWidth?:boolean,
    icon?:string,
    disabled?:boolean,
    type?:any,
}
const Button = ({
    children,
    className,
    wrapperClassName,
    buttonType,
    onClick,
    fullWidth,
    icon,
    disabled,
    type
}:ButtonProps) => {
    let buttonStyle = {};
    buttonStyle = {
        ...buttonStyle,
        ...(fullWidth && {width: '100%'}), //If the property exists (no value needed), this Style will be applied
    }
    return (
        <span className={`form-group button-container${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            <button
                type={type ? type : "button"}
                className={`button${buttonType ? ' button-' + buttonType : ''}${className ? ' ' + className : ''}${icon ? ' icon-' + icon : ''}`}
                onClick={onClick}
                style={buttonStyle}
                disabled={disabled}
            >
                {children}
            </button>
        </span>
    )
}

export default Button;
